export const Colors ={
   blue:{
    regular:"#1A56DB",
    light:"#C3DDFD",
    lighter:"#E1EFFE"
   }
}